export default __webpack_public_path__ + "static/media/018-cobweb.b4eb91a8.svg";